var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20654 1.5H5.20654C5.10709 1.5 5.0117 1.53951 4.94138 1.60984C4.87105 1.68016 4.83154 1.77554 4.83154 1.875V3.75H2.95654C2.85709 3.75 2.7617 3.78951 2.69138 3.85984C2.62105 3.93016 2.58154 4.02554 2.58154 4.125V10.125C2.58154 10.2245 2.62105 10.3198 2.69138 10.3902C2.7617 10.4605 2.85709 10.5 2.95654 10.5H6.95654C7.056 10.5 7.15138 10.4605 7.22171 10.3902C7.29203 10.3198 7.33154 10.2245 7.33154 10.125V8.25H9.20654C9.306 8.25 9.40138 8.21049 9.47171 8.14017C9.54203 8.06984 9.58154 7.97446 9.58154 7.875V1.875C9.58154 1.77554 9.54203 1.68016 9.47171 1.60984C9.40138 1.53951 9.306 1.5 9.20654 1.5ZM6.58154 9.75H3.33154V4.5H6.58154V9.75ZM8.83154 7.5H7.33154V4.125C7.33154 4.02554 7.29203 3.93016 7.22171 3.85984C7.15138 3.78951 7.056 3.75 6.95654 3.75H5.58154V2.25H8.83154V7.5Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.11690948cec376ec98c128635f0bc2ca.svg";
export { ForwardRef as ReactComponent };